const Checkbox = ({ checked, label, onChange }: { checked: boolean, label: any, onChange: (newValue: boolean) => void }) => {
  return (
    <div className="vintage-controls checkbox-row">
      <input
        type="checkbox"
        id={label.toString()}
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <label htmlFor={label.toString()}>{label}</label>
    </div>
  )
}

export default Checkbox;
